import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "label"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (props) {
  if (props === void 0) {
    props = {};
  }
  var {
      prefixCls = 'w-tabs-pane',
      className
    } = props,
    resetProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("div", _extends({
    className: [prefixCls, className].filter(Boolean).join(' ').trim()
  }, resetProps));
});